import { ReactComponent as UploadAvatar } from 'assets/images/upload-avatar.svg';

import styles from './styles.module.scss';
import React, { useCallback, useRef } from 'react';

type InputProps = {
  avatarUrl: string;
  onChange: (file: File) => void;
};

export const UserProfileUploadAvatar = ({
  avatarUrl,
  onChange,
}: InputProps) => {
  const inputFile: any = useRef(null);

  function handleChange(e: any) {
    onChange(e.target.files[0]);
  }

  const onClickHandler = useCallback(() => {
    inputFile.current.click();
    inputFile.current.value = '';
  }, [inputFile]);

  return (
    <div className={styles.root}>
      <div onClick={onClickHandler}>
        {avatarUrl ? <img src={avatarUrl} alt="Avatar" /> : <UploadAvatar />}
      </div>
      <input
        onChange={handleChange}
        ref={inputFile}
        accept="image/png, image/jpg, image/jpeg"
        type="file"
      />
    </div>
  );
};
